"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FSMRepository = void 0;

var _visData = require("vis-data");

var _xstate = require("xstate");

var _fsm2 = require("./fsm.interceptor");

var _stateMachine = require("../services/state-machine.service");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var is = require("is_js");

var ENTITY = "fsm";
var MODULE_NAME = "fsm.repo";
var ERROR_LOOKUP_TABLE = {
  UNKNOWN_ERROR: {
    error_code: "500",
    error_type: "UNKNOWN_ERROR",
    error_message: null,
    display_message: "unknown error in ".concat(ENTITY, " Validation")
  },
  ENTITY_NOT_FOUND: {
    error_code: "404",
    error_type: "NOT_FOUND_ERROR",
    error_message: "Given ".concat(ENTITY, " is not found"),
    display_message: "".concat(ENTITY, " for the request is not determined")
  },
  ENTITY_ALREADY_FOUND: {
    error_code: "409",
    error_type: "ALREADY_EXISTS_ERROR",
    error_message: "Given ".concat(ENTITY, " is already exist"),
    display_message: "".concat(ENTITY, " for the request is already found")
  }
};

var FSMRepository = /*#__PURE__*/function () {
  function FSMRepository() {
    _classCallCheck(this, FSMRepository);

    _defineProperty(this, "fsmRepoData", void 0);

    _defineProperty(this, "validator", void 0);

    _defineProperty(this, "stateMachineService", void 0);

    this.validator = _fsm2.FSMRepoInterceptor === null || _fsm2.FSMRepoInterceptor === void 0 ? void 0 : _fsm2.FSMRepoInterceptor.getInstance();
    this.stateMachineService = _stateMachine.StateMachineService === null || _stateMachine.StateMachineService === void 0 ? void 0 : _stateMachine.StateMachineService.getInstance();
    this.fsmRepoData = new _visData.DataSet();
  }

  _createClass(FSMRepository, [{
    key: "createFSM",
    value: function () {
      var _createFSM = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params, services) {
        var arg, _entity2, _entity3, _entity4, _entity5, _entity6, _res4, machine, _entity, _res3, _res2, _res, _res6, _res5;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.validator.create(params);

              case 2:
                arg = _context.sent;

                if (!(arg && is.existy(arg.error))) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", arg.error);

              case 5:
                _context.prev = 5;
                machine = this.stateMachineService.createMachine({
                  id: arg.id,
                  initial: arg.initial,
                  context: arg.context,
                  states: arg.states
                }, services);
                _entity = this.fsmRepoData.get(arg.id);

                if (!_entity) {
                  _context.next = 11;
                  break;
                }

                _res2 = (_res3 = {}, _defineProperty(_res3, ENTITY, null), _defineProperty(_res3, "error", ERROR_LOOKUP_TABLE.ENTITY_ALREADY_FOUND), _res3);
                return _context.abrupt("return", _res2);

              case 11:
                if (machine) {
                  arg.states = JSON.stringify(arg.states);
                  arg.currentState = null;
                }

                _entity = this.fsmRepoData.update(arg);
                _res = (_res4 = {}, _defineProperty(_res4, ENTITY, {
                  id: (_entity2 = _entity) === null || _entity2 === void 0 ? void 0 : _entity2.id,
                  initial: (_entity3 = _entity) === null || _entity3 === void 0 ? void 0 : _entity3.initial,
                  context: (_entity4 = _entity) === null || _entity4 === void 0 ? void 0 : _entity4.context,
                  states: (_entity5 = _entity) === null || _entity5 === void 0 ? void 0 : _entity5.states,
                  machine: machine,
                  currentState: (_entity6 = _entity) === null || _entity6 === void 0 ? void 0 : _entity6.currentState
                }), _defineProperty(_res4, "error", null), _res4);
                return _context.abrupt("return", _res);

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](5);
                _res5 = (_res6 = {}, _defineProperty(_res6, ENTITY, null), _defineProperty(_res6, "error", _objectSpread(_objectSpread({}, ERROR_LOOKUP_TABLE.UNKNOWN_ERROR), {}, {
                  error_message: _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message
                })), _res6);
                return _context.abrupt("return", _res5);

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 17]]);
      }));

      function createFSM(_x, _x2) {
        return _createFSM.apply(this, arguments);
      }

      return createFSM;
    }()
  }, {
    key: "deleteFSM",
    value: function () {
      var _deleteFSM = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(params) {
        var arg, _entity, _res7, _res;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.validator.delete(params);

              case 2:
                arg = _context2.sent;

                if (!(arg && is.existy(arg.error))) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", arg.error);

              case 5:
                _context2.prev = 5;
                _context2.next = 8;
                return this.stateMachineService.deleteMachine(arg.value);

              case 8:
                _entity = this.fsmRepoData.remove(arg.value);

                if (is.not.existy(_entity)) {// log.error(
                  //   `error in deleteFSM ${ENTITY}:  ${ERROR_LOOKUP_TABLE.ENTITY_NOT_FOUND.display_message}`
                  // );
                }

                _context2.next = 16;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](5);
                // log.error(`error in delete ${ENTITY}:  ${err.message}`);
                _res = (_res7 = {}, _defineProperty(_res7, ENTITY, null), _defineProperty(_res7, "error", _objectSpread(_objectSpread({}, ERROR_LOOKUP_TABLE.UNKNOWN_ERROR), {}, {
                  error_message: _context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message
                })), _res7);
                return _context2.abrupt("return", _res);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 12]]);
      }));

      function deleteFSM(_x3) {
        return _deleteFSM.apply(this, arguments);
      }

      return deleteFSM;
    }()
  }, {
    key: "updateFSM",
    value: function () {
      var _updateFSM = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(params) {
        var arg, _res8, _entity, _res, _res10, _res9;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.validator.update(params);

              case 2:
                arg = _context3.sent;

                if (!(arg && is.existy(arg.error))) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return", arg.error);

              case 5:
                _context3.prev = 5;

                if (arg.currentState) {
                  try {
                    arg.currentState = JSON.stringify(arg.currentState);
                  } catch (err) {}
                }

                _entity = this.fsmRepoData.updateOnly({
                  id: arg.id,
                  currentState: arg.currentState
                });
                _res = (_res8 = {}, _defineProperty(_res8, ENTITY, {
                  id: _entity === null || _entity === void 0 ? void 0 : _entity.id,
                  initial: _entity === null || _entity === void 0 ? void 0 : _entity.initial,
                  context: _entity === null || _entity === void 0 ? void 0 : _entity.context,
                  states: _entity === null || _entity === void 0 ? void 0 : _entity.states,
                  currentState: _entity === null || _entity === void 0 ? void 0 : _entity.currentState
                }), _defineProperty(_res8, "error", null), _res8);
                return _context3.abrupt("return", _res);

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](5);
                //  log.error(`error in update ${ENTITY}:  ${err.message}`);
                _res9 = (_res10 = {}, _defineProperty(_res10, ENTITY, null), _defineProperty(_res10, "error", _objectSpread(_objectSpread({}, ERROR_LOOKUP_TABLE.UNKNOWN_ERROR), {}, {
                  error_message: _context3.t0 === null || _context3.t0 === void 0 ? void 0 : _context3.t0.message
                })), _res10);
                return _context3.abrupt("return", _res9);

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[5, 12]]);
      }));

      function updateFSM(_x4) {
        return _updateFSM.apply(this, arguments);
      }

      return updateFSM;
    }()
  }, {
    key: "getFSM",
    value: function () {
      var _getFSM = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(params) {
        var arg, _res13, _entity, _res12, _res11, _states, _currentState, machine, resolvedState, machineFound, previousState, _res, _res15, _res14;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.validator.get(params);

              case 2:
                arg = _context4.sent;

                if (!(arg && is.existy(arg.error))) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return", arg.error);

              case 5:
                _context4.prev = 5;
                _entity = this.fsmRepoData.get(arg.value);

                if (!is.not.existy(_entity)) {
                  _context4.next = 10;
                  break;
                }

                // log.error(
                //   `error in get ${ENTITY}:  ${ERROR_LOOKUP_TABLE.ENTITY_NOT_FOUND.display_message}`
                // );
                _res11 = (_res12 = {}, _defineProperty(_res12, ENTITY, null), _defineProperty(_res12, "error", ERROR_LOOKUP_TABLE.ENTITY_NOT_FOUND), _res12);
                return _context4.abrupt("return", _res11);

              case 10:
                _states = _entity === null || _entity === void 0 ? void 0 : _entity.states;

                if (_entity !== null && _entity !== void 0 && _entity.states && is.string(_entity === null || _entity === void 0 ? void 0 : _entity.states)) {
                  try {
                    _states = JSON.parse(_entity === null || _entity === void 0 ? void 0 : _entity.states);
                  } catch (err) {}
                }

                _currentState = _entity === null || _entity === void 0 ? void 0 : _entity.currentState;

                if (_entity !== null && _entity !== void 0 && _entity.currentState && is.string(_entity === null || _entity === void 0 ? void 0 : _entity.currentState)) {
                  try {
                    _currentState = JSON.parse(_entity === null || _entity === void 0 ? void 0 : _entity.currentState);
                  } catch (err) {}
                }

                resolvedState = null;

                if (_entity) {
                  machineFound = this.stateMachineService.findMachine(_entity.id);
                  machine = machineFound === null || machineFound === void 0 ? void 0 : machineFound.machine;
                }

                previousState = _xstate.State.create(_currentState || machine.initialState);
                resolvedState = machine.resolveState(previousState);
                _res = (_res13 = {}, _defineProperty(_res13, ENTITY, {
                  id: _entity === null || _entity === void 0 ? void 0 : _entity.id,
                  resolvedState: resolvedState,
                  machine: machine
                }), _defineProperty(_res13, "error", null), _res13);
                return _context4.abrupt("return", _res);

              case 22:
                _context4.prev = 22;
                _context4.t0 = _context4["catch"](5);
                // log.error(`error in get ${ENTITY}:  ${err.message}`);
                _res14 = (_res15 = {}, _defineProperty(_res15, ENTITY, null), _defineProperty(_res15, "error", _objectSpread(_objectSpread({}, ERROR_LOOKUP_TABLE.UNKNOWN_ERROR), {}, {
                  error_message: _context4.t0 === null || _context4.t0 === void 0 ? void 0 : _context4.t0.message
                })), _res15);
                return _context4.abrupt("return", _res14);

              case 26:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[5, 22]]);
      }));

      function getFSM(_x5) {
        return _getFSM.apply(this, arguments);
      }

      return getFSM;
    }()
  }, {
    key: "transitTo",
    value: function () {
      var _transitTo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(machineId, type) {
        var _this = this;

        var arg, _fsm$fsm, _fsm$fsm2, _fsm$fsm3, _fsm, _res16, _res, service, _res18, _res17;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.validator.transitTo({
                  id: machineId,
                  type: type
                });

              case 2:
                arg = _context6.sent;

                if (!(arg && is.existy(arg.error))) {
                  _context6.next = 5;
                  break;
                }

                return _context6.abrupt("return", arg.error);

              case 5:
                _context6.prev = 5;
                _context6.next = 8;
                return this.getFSM({
                  type: "id",
                  value: arg.id
                });

              case 8:
                _fsm = _context6.sent;

                if (!is.not.existy(_fsm === null || _fsm === void 0 ? void 0 : (_fsm$fsm = _fsm.fsm) === null || _fsm$fsm === void 0 ? void 0 : _fsm$fsm.machine)) {
                  _context6.next = 12;
                  break;
                }

                // log.error(
                //   `error in transitTo ${ENTITY}:  ${ERROR_LOOKUP_TABLE.ENTITY_NOT_FOUND.display_message}`
                // );
                _res = (_res16 = {}, _defineProperty(_res16, ENTITY, null), _defineProperty(_res16, "error", ERROR_LOOKUP_TABLE.ENTITY_NOT_FOUND), _res16);
                return _context6.abrupt("return", _res);

              case 12:
                service = (0, _xstate.interpret)(_fsm === null || _fsm === void 0 ? void 0 : (_fsm$fsm2 = _fsm.fsm) === null || _fsm$fsm2 === void 0 ? void 0 : _fsm$fsm2.machine).onTransition( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(state) {
                    return regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            if (state.changed) {
                              _this.stateChangeListener(machineId, state);
                            }

                            if (state.done) {
                              _this.finalStateListener(machineId, state);
                            }

                          case 2:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5);
                  }));

                  return function (_x8) {
                    return _ref.apply(this, arguments);
                  };
                }()).start(_fsm === null || _fsm === void 0 ? void 0 : (_fsm$fsm3 = _fsm.fsm) === null || _fsm$fsm3 === void 0 ? void 0 : _fsm$fsm3.resolvedState);
                service.send({
                  type: type
                });
                _context6.next = 20;
                break;

              case 16:
                _context6.prev = 16;
                _context6.t0 = _context6["catch"](5);
                // log.error(`error in transitTo ${ENTITY}:  ${err.message}`);
                _res17 = (_res18 = {}, _defineProperty(_res18, ENTITY, null), _defineProperty(_res18, "error", _objectSpread(_objectSpread({}, ERROR_LOOKUP_TABLE.UNKNOWN_ERROR), {}, {
                  error_message: _context6.t0 === null || _context6.t0 === void 0 ? void 0 : _context6.t0.message
                })), _res18);
                return _context6.abrupt("return", _res17);

              case 20:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[5, 16]]);
      }));

      function transitTo(_x6, _x7) {
        return _transitTo.apply(this, arguments);
      }

      return transitTo;
    }()
  }, {
    key: "invokeAction",
    value: function () {
      var _invokeAction = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(context, event) {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", new Promise(function (resolve, reject) {
                  resolve(true);
                }));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function invokeAction(_x9, _x10) {
        return _invokeAction.apply(this, arguments);
      }

      return invokeAction;
    }()
  }, {
    key: "stateChangeListener",
    value: function () {
      var _stateChangeListener = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(machineId, state) {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.updateFSM({
                  id: machineId,
                  currentState: state
                });

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function stateChangeListener(_x11, _x12) {
        return _stateChangeListener.apply(this, arguments);
      }

      return stateChangeListener;
    }()
  }, {
    key: "finalStateListener",
    value: function () {
      var _finalStateListener = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(machineId, state) {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                this.deleteFSM({
                  type: "id",
                  value: machineId
                });

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function finalStateListener(_x13, _x14) {
        return _finalStateListener.apply(this, arguments);
      }

      return finalStateListener;
    }()
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!this.instance) {
        this.instance = new FSMRepository();
      }

      return this.instance;
    }
  }]);

  return FSMRepository;
}();

exports.FSMRepository = FSMRepository;

_defineProperty(FSMRepository, "instance", void 0);